<script>
import axios from 'axios'
export default
{
    name: 'simple-image-uploader',

    props:
    {
        text: String,
        type: String,
        accept: String,
        disabled: Boolean,
        multiple: Boolean,
    },

    methods:
    {
        handleInput(e)
        {
            let hasError = false
            const files = e.target.files
            if (!files ||  !files.length) return
            const formData = new FormData() // @TODO: Check Safari/IE shit
            Array
                .from(Array(files.length).keys())
                .map(x => {
                    formData.append('file', files[x], files[x].name)
                })
            if (!hasError) this.upload(formData)
        },

        upload(formData)
        {
            this.loading = true
            formData.append('type', this.type)
            const url =  `${process.env.API_SERVER}/attachments/upload-image`
            axios.post(url, formData).then(res => {
                this.$emit('upload-done', res.data)
                this.loading = false
                this.reset()
            }).catch(e => {
                this.loading = false
            })
        },

        reset()
        {
            this.$emit('clean')
        },

        onFileChoose()
        {
            this.$emit('dirty')
        },
    },

    data()
    {
        return {
            loading: false,
            image: {}
        }
    },

}
</script>
<template>
    <div class="image-uploader">
        <label>
            <input type="file" name="image" @change="handleInput" :multiple="multiple" :disabled="disabled" :accept="accept"> 
        </label>
        <div class="engage-button xs text-blue" v-show="image && image.imageSet" @click.prevent.stop="upload">
            Upload
        </div>

        <div class="engage-button orange text-white xs" v-show="image && image.imageSet" @click.prevent.stop="reset">
            Delete
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/SimpleImageUploader.vue